import { OrdersProvider } from '../OrdersProvider';
import { Headers } from '../types';
import { ApiClientFactory } from './clients';

export class OrdersProviderFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/order`, headers);
  }

  public createOrderProvider(authToken: string): OrdersProvider {
    return new OrdersProvider(this.apiClientFactory.createAuthorizedClient(authToken));
  }
}
